module.exports = __webpack_public_path__ + "img/antes_despues_333.9d75aef6.png";